<template>
  <div>
    <b-row>
      <b-col lg="6">
        <b-form-group label="*Name" label-for="landing-name">
          <b-form-input
            id="landing-name"
            name="landing-name"
            type="text"
            size="lg"
            required
            v-model="form.name"
          />
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group
          label="Distribution algorithm"
          label-for="distribution-types"
        >
          <multi-select
            id="distribution-types"
            :select-options="distributionTypes"
            :options="{ multi: false }"
            v-model="form.distribution"
            btn-label="Choose distribution type"
            size="lg"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <h3 class="text-light mb-3">Landing pages</h3>
      </b-col>
      <b-col sm="12">
        <div class="mb-5">
          <b-form-group label="Mass links import">
            <b-form-textarea
              size="lg"
              placeholder="Enter multiple links separeted by new line and generate list"
              class="mb-1"
              v-model="linksSetsList"
              rows="4"
            />
            <button
              id="generate-sets"
              class="btn btn-sm btn-success"
              @click="generateSets"
            >
              Generate list
            </button>
          </b-form-group>
        </div>
      </b-col>
      <template v-for="(set, index) in linkSets">
        <!-- <b-col lg="6" :key="`name-${index}`">
          <b-form-group label="*Name" :label-for="`landing-name-${index}`">
            <b-form-input
              :id="`landing-name-${index}`"
              :name="`landing-name-${index}`"
              type="text"
              size="lg"
              required
              v-model="linkSets[index].name"
            />
          </b-form-group>
        </b-col> -->
        <b-col
          :key="`url-${index}`"
          cols="11"
          :lg="form.distribution[0].name === 'fixed' ? 8 : 11"
        >
          <b-form-group>
            <b-form-label
              slot="label"
              label="*Url"
              :for="`landing-url-${index}`"
              :errors="linksState[`link-${index}`]"
            />
            <b-form-input
              :id="`landing-url-${index}`"
              :name="`landing-url-${index}`"
              type="text"
              size="lg"
              :state="linksState[`link-${index}`] ? false : null"
              required
              v-model="linkSets[index].url"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="form.distribution[0].name === 'fixed'"
          cols="11"
          lg="3"
          :key="`share-${index}`"
        >
          <b-form-group>
            <b-form-label
              slot="label"
              label="*Share %"
              :for="`landing-share-${index}`"
            />
            <b-input-number
              v-model="linkSets[index].rate"
              :id="`landing-share-${index}`"
              :name="`landing-share-${index}`"
              type="text"
              size="lg"
              required
            />
          </b-form-group>
        </b-col>
        <b-col cols="1" :key="`remove-${index}`" class="text-center">
          <button
            class="btn-link-alt btn-link-primary mt-7"
            :class="{ 'is-disabled': linkSets.length === 1 }"
            title="Remove set"
            @click="removeSet(index)"
            :disabled="linkSets.length === 1"
          >
            <svg-icon icon="cancel-circle" class="icon-xl text-danger" />
          </button>
        </b-col>
      </template>
    </b-row>
    <div class="mt-3">
      <button
        id="add-set"
        @click="addSet()"
        class="btn btn-sm btn-success float-left"
      >
        {{ $t('add') }}
      </button>
      <button
        id="submit-creative"
        @click="submit()"
        class="btn btn-sm btn-primary float-right"
        :disabled="submitDisabled"
      >
        {{ $t('save') }}
      </button>
    </div>
  </div>
</template>

<script>
import isLink from '@/utils/isLink.js';
import cloneDeep from 'clone';

export default {
  props: {
    group: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      linksSetsList: null,
      distributionTypes: this.$store.getters['advert/landingsDistribution'],
      form: {
        distribution: [{ id: 0, name: 'even' }],
        name: null
      },
      linkSets: [
        {
          url: null,
          rate: null
        }
      ],
      linksState: {},
      errors: {}
    };
  },

  computed: {
    userId() {
      return this.$store.getters.user.id;
    },
    submitDisabled() {
      return (
        Object.entries(this.linksState).length !== 0 ||
        !this.linkSets[0].url ||
        !this.form.name
      );
    }
  },

  watch: {
    linkSets: {
      deep: true,
      handler(list) {
        this.linksState = {};
        const joinedList = list
          .map(link => {
            return link.url;
          })
          .join('\n');

        this.linksSetsList = joinedList;
        this.checkLinks(list);
      }
    }
  },

  methods: {
    generateSets() {
      if (!this.linksSetsList || this.linksSetsList.length === 0) return false;
      const splittedList = this.linksSetsList.split(/\n/);
      const processedList = splittedList
        .filter(link => link.trim().length !== 0)
        .map(link => {
          return {
            url: link.trim(),
            rate: null
          };
        });
      this.linkSets = processedList;
    },
    checkLinks(list) {
      list.forEach((link, index) => {
        if (!isLink(link.url)) {
          this.linksState[`link-${index}`] = 'Incorrect url';
        }
      });
    },
    addSet() {
      this.linkSets.push({ url: null, rate: null });
    },
    removeSet(index) {
      this.linkSets.splice(index, 1);
    },
    submit() {
      if (!this.isEdit) {
        this.createGroup();
      } else {
        this.updateGroup();
      }
    },
    createGroup() {
      const newGroup = {
        name: this.form.name,
        algorithm: this.form.distribution[0].id,
        landings: cloneDeep(this.linkSets),
        ownerID: this.$store.getters.user.id
      };
      this.$api.adnet.post('/dsp/landing-groups/', newGroup).then(
        () => {
          this.errors = {};
          this.$emit('form-submitted', { success: true });
          this.$notify('alert', {
            text: `New landings group added.`,
            variant: 'success',
            time: 5000
          });
        },
        e => {
          this.errors = {};

          if (e.response.data.errors) {
            this.errors = this.$parseErrors(e.response.data.errors) || {};
          } else {
            this.$emit('form-submitted', { success: false });
            e.response.data.detail &&
              this.$notify('alert', {
                text: e.response.data.detail,
                variant: 'danger',
                time: 0
              });
          }
        }
      );
    },
    updateGroup() {
      const updatedGroup = cloneDeep(this.group);
      updatedGroup.name = this.form.name;
      updatedGroup.algorithm = this.form.distribution[0].id;
      updatedGroup.landings = cloneDeep(this.linkSets);

      this.$api.adnet
        .put(`/dsp/landing-groups/${updatedGroup.id}`, updatedGroup)
        .then(
          () => {
            this.errors = {};
            this.$emit('form-submitted', { success: true });
            this.$notify('alert', {
              text: `Landing group "${updatedGroup.name}" updated.`,
              variant: 'success',
              time: 5000
            });
          },
          e => {
            this.errors = {};

            if (e.response.data.errors) {
              this.errors = this.$parseErrors(e.response.data.errors) || {};
            } else {
              this.$emit('form-submitted', { success: false });
              e.response.data.detail &&
                this.$notify('alert', {
                  text: e.response.data.detail,
                  variant: 'danger',
                  time: 0
                });
            }
          }
        );
    }
  },

  created() {
    if (this.isEdit) {
      this.form.distribution = [
        cloneDeep(
          this.$store.getters['advert/getLandingDistributionById'](
            this.group.algorithm
          )
        )
      ];
      this.form.name = this.group.name;
      this.linkSets = cloneDeep(this.group.landings);
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-link-alt.is-disabled {
  cursor: default;
  i {
    color: $light !important;
  }
}
</style>
